import React, { PropTypes } from 'react';

import './style.scss';

const DetailLabel = (props) => <div className="DetailLabel">{props.children}</div>;

DetailLabel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

export default DetailLabel;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/DetailLabel/index.js
 **/